module.exports = __webpack_public_path__ + "static/img/5bg_3.63a39d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_3.png
// module id = 728
// module chunks = 1